module.exports = __webpack_public_path__ + "media/images/daopool-logo-e74cd7de.png";